import { useMap } from "react-leaflet";

function ChangeCenter({ lat, lng }) {
  const map = useMap();
  if (lat === undefined) return null;
  if (lng === undefined) return null;
  map.setView([lat, lng]);
  return null;
}

export default ChangeCenter;
